import { CellTable } from "@/atoms"
import { getDefaultColumnParams } from "@/helpers/table.helpers"
import { StatusTagCell } from "@/molecules/StatusTagCell"
import { ReportIdCell } from "@/pages/ReportsPage/components/molecules/ReportIdCell"
import { TranslationKeyCell } from "@/pages/ReportsPage/components/molecules/TranslationKeyCell"
import { getCreatorColumn } from "@/pages/ReportsPage/helpers/table.helper"
import { WarehouseReportsActionsCell as Control } from "./components/WarehouseReportsActionsCell"

export const getColumnsTable = (props: any) => [
  {
    title: "Report Name",
    render: CellTable,
    ...getDefaultColumnParams("definitionName")
  },
  {
    title: "Report Type",
    width: 150,
    render: TranslationKeyCell(props.t),
    ...getDefaultColumnParams("reportTypeKey")
  },
  {
    title: "Scope",
    render: CellTable,
    ...getDefaultColumnParams("scopesDisplayValue")
  },
  {
    title: "#ID",
    width: 135,
    render: ReportIdCell,
    ...getDefaultColumnParams("id")
  },
  {
    title: "Status",
    width: 90,
    render: StatusTagCell(props.t),
    ...getDefaultColumnParams("statusValue")
  },
  getCreatorColumn(),
  {
    title: "Generated",
    width: 155,
    render: CellTable,
    ...getDefaultColumnParams("generatedAt")
  },
  {
    title: null,
    width: 35,
    render: Control(props)
  }
]
